// assets/pubsub-init.js
// Universal PubSub initialization that works with all components

(function() {
  'use strict';
  
  // Check if pubsub already exists (from another script)
  if (window.PubSub && window.PubSub.subscribe && window.PubSub.publish) {
    // console.log('PubSub already initialized, skipping');
    return;
  }

  // Initialize subscribers storage
  window.subscribers = window.subscribers || {};

  // Create the core subscribe function
  const subscribe = function(eventName, callback) {
    if (!window.subscribers[eventName]) {
      window.subscribers[eventName] = [];
    }

    window.subscribers[eventName].push(callback);

    return function unsubscribe() {
      if (window.subscribers[eventName]) {
        window.subscribers[eventName] = window.subscribers[eventName].filter(cb => cb !== callback);
      }
    };
  };

  // Create the core publish function
  const publish = function(eventName, data) {
    // console.log(`[PubSub] Publishing event: ${eventName}`, data);
    
    // First, try the subscribers array
    if (window.subscribers && window.subscribers[eventName]) {
      const promises = window.subscribers[eventName].map(callback => {
        try {
          return Promise.resolve(callback(data));
        } catch (error) {
          console.error(`[PubSub] Error in subscriber for ${eventName}:`, error);
          return Promise.resolve();
        }
      });
      return Promise.all(promises);
    }
    
    // Also dispatch as CustomEvent for compatibility
    try {
      const event = new CustomEvent(eventName, { 
        detail: data,
        bubbles: true,
        cancelable: false
      });
      document.dispatchEvent(event);
    } catch (e) {
      console.error('[PubSub] Error dispatching CustomEvent:', e);
    }
    
    return Promise.resolve();
  };

  // Define PUB_SUB_EVENTS globally
  window.PUB_SUB_EVENTS = {
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant:change',
    cartUpdate: 'cart-update',
    cartError: 'cart-error',
    cartDrawerOpen: 'cart-drawer:open',
    cartDrawerClose: 'cart-drawer:close'
  };

  // Set up global access in multiple ways for compatibility
  window.publish = publish;
  window.subscribe = subscribe;
  window.PubSub = { 
    subscribe: subscribe, 
    publish: publish,
    unsubscribe: function(eventName, callback) {
      if (window.subscribers[eventName]) {
        window.subscribers[eventName] = window.subscribers[eventName].filter(cb => cb !== callback);
      }
    }
  };

  // Also set up CustomEvent listeners for any component using that approach
  const customEventSubscribe = function(eventName, callback) {
    const handler = function(event) {
      callback(event.detail);
    };
    
    document.addEventListener(eventName, handler);
    
    return function unsubscribe() {
      document.removeEventListener(eventName, handler);
    };
  };

  // Provide both methods
  window.customEventSubscribe = customEventSubscribe;
  
  // console.log('[PubSub] Initialization complete');
})();